import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.map.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  "class": "relative"
};
var _hoisted_2 = {
  "class": "Notifications__top"
};
var _hoisted_3 = {
  "class": "PBDropdown__list scroller"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  "class": "Notifications__content"
};
var _hoisted_6 = {
  "class": "Notifications__title"
};
var _hoisted_7 = {
  "class": "Notifications__date"
};
var _hoisted_8 = ["innerHTML"];
var _hoisted_9 = {
  key: 1,
  "class": "Notifications__empty"
};
var _hoisted_10 = {
  "class": "Notifications__bottom rounded-b-md"
};
import { GLOBAL_EVENTS } from "@/constants/global-events";

import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useEventBus } from '@vueuse/core';
import { ref, computed, onMounted, nextTick } from 'vue';
export default {
  __name: 'Notifications',
  setup: function setup(__props) {
    var store = useStore();
    var router = useRouter();
    var openNotificationsBus = useEventBus(GLOBAL_EVENTS.OPEN_NOTIFICATIONS);
    var expanded = ref([]);
    var isShown = ref(false);
    var contentRef = ref(null);
    var notifications = computed(function () {
      return store.state.notifications.notifications;
    });
    var newNotifications = computed(function () {
      return store.getters["notifications/newNotifications"];
    });
    var titlesMap = computed(function () {
      return store.getters["notifications/titlesMap"];
    });
    var formattedNotifications = computed(function () {
      return store.getters["notifications/formattedNotifications"];
    });
    var newNotificationsLabel = computed(function () {
      var count = newNotifications.value.length;
      return "".concat(count, " new notification").concat(count > 1 ? "s" : "");
    });
    var alert = computed(function () {
      if (!newNotifications.value) {
        return false;
      }
      return newNotifications.value.length > 0;
    });
    function openDropdown() {
      isShown.value = true;
    }
    function hideDropdown() {
      isShown.value = false;
      setTimeout(function () {
        return expanded.value = [];
      }, 250);
    }
    function expandMessage(message) {
      if (expanded.value.includes(message.id)) {
        return expanded.value.splice(expanded.value.indexOf(message.id), 1);
      }
      expanded.value.push(message.id);
      markRead([message]);
    }
    function markRead(_x) {
      return _markRead.apply(this, arguments);
    }
    function _markRead() {
      _markRead = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(items) {
        var ids, _iterator2, _step2, notification;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(items[0].isRead || newNotifications.value.length === 0)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              ids = items.map(function (notification) {
                return notification.id;
              });
              store.dispatch("notifications/markRead", ids);
              _iterator2 = _createForOfIteratorHelper(notifications.value);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  notification = _step2.value;
                  if (ids.includes(notification.id)) {
                    notification.isRead = true;
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _markRead.apply(this, arguments);
    }
    function getNotificationText(message) {
      var params = message.params;
      var textTemplate = store.getters["notifications/textsMap"][message.type];
      if (!params || Object.keys(params).length === 0) {
        return textTemplate;
      }
      for (var key in params) {
        var regEx = new RegExp("{".concat(key, "}"), "g");
        textTemplate = textTemplate.replace(regEx, params[key]);
      }
      return textTemplate;
    }
    openNotificationsBus.on(function () {
      return isShown.value = true;
    });
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var activePortfolioId, paragraphs, _iterator, _step, paragraph, link;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            activePortfolioId = store.state.portfolio.activePortfolioId;
            if (!activePortfolioId) {
              _context.next = 4;
              break;
            }
            _context.next = 4;
            return store.dispatch("notifications/fetch");
          case 4:
            _context.next = 6;
            return nextTick();
          case 6:
            paragraphs = contentRef.value.querySelectorAll("p");
            _iterator = _createForOfIteratorHelper(paragraphs);
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                paragraph = _step.value;
                if (paragraph) {
                  link = paragraph.querySelector("a");
                  if (link) {
                    link.addEventListener("click", function (e) {
                      e.preventDefault();
                      router.push(e.target.dataset.href);
                    });
                  }
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return function (_ctx, _cache) {
      var _component_PBIcon = _resolveComponent("PBIcon");
      var _component_PBStatus = _resolveComponent("PBStatus");
      var _component_RouterLink = _resolveComponent("RouterLink");
      var _component_PBDropdown = _resolveComponent("PBDropdown");
      return _openBlock(), _createBlock(_component_PBDropdown, {
        selectable: false,
        chevron: false,
        "no-padding": "",
        width: "414px",
        "is-shown": _unref(isShown),
        onHideDropdown: hideDropdown,
        onOpenDropdown: openDropdown
      }, {
        icon: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createVNode(_component_PBIcon, {
            name: "bell",
            w: 16,
            h: 20
          }), _createElementVNode("div", {
            "class": _normalizeClass({
              Notifications__alert: true,
              visible: _unref(alert)
            })
          }, null, 2)])];
        }),
        top: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [_createTextVNode(_toDisplayString(_unref(newNotificationsLabel)) + " ", 1), _createElementVNode("a", {
            "class": _normalizeClass({
              disabled: _unref(newNotifications).length === 0
            }),
            href: "#",
            onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
              return markRead(_unref(newNotifications));
            }, ["prevent"]))
          }, " Mark all as read ", 2)])];
        }),
        menu: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
            ref_key: "contentRef",
            ref: contentRef,
            "class": "PBDropdown__item"
          }, [_unref(formattedNotifications).length ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(_unref(formattedNotifications), function (message, index) {
            return _openBlock(), _createElementBlock("div", {
              key: index
            }, [_createElementVNode("div", {
              "class": _normalizeClass({
                Notifications__item: true,
                "new": !message.isRead
              }),
              onClick: function onClick($event) {
                return expandMessage(message);
              }
            }, [_cache[2] || (_cache[2] = _createElementVNode("div", {
              "class": "Notifications__indicator"
            }, null, -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createTextVNode(_toDisplayString(_unref(titlesMap)[message.type]) + " ", 1), _createElementVNode("div", _hoisted_7, _toDisplayString(message.date), 1)]), _createElementVNode("p", {
              "class": _normalizeClass({
                expanded: _unref(expanded).includes(message.id)
              }),
              onClick: _cache[1] || (_cache[1] = _withModifiers(function () {}, ["stop"])),
              innerHTML: getNotificationText(message)
            }, null, 10, _hoisted_8)])], 10, _hoisted_4)]);
          }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_PBStatus, {
            empty: "",
            note: "",
            message: "No updates yet"
          }, {
            "custom-icon": _withCtx(function () {
              return [_createVNode(_component_PBIcon, {
                name: "bell",
                w: 16,
                h: 20
              })];
            }),
            _: 1
          })]))], 512)])];
        }),
        bottom: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_10, [_createVNode(_component_RouterLink, {
            to: "/notifications",
            onClick: hideDropdown
          }, {
            "default": _withCtx(function () {
              return _toConsumableArray(_cache[3] || (_cache[3] = [_createTextVNode(" Show all notifications ", -1)]));
            }),
            _: 1
          })])];
        }),
        _: 1
      }, 8, ["is-shown"]);
    };
  }
};